<template>
	<layout-content class="app-home-vue-h  frame-page">
		<Row :space="24">
			<Cell width="8">
				<div class="h-panel" style="height: 300px">
					<div class="h-panel-bar">
						<div class="h-panel-title">生日提醒</div>
					</div>
					<div class="h-panel-body">
						<Row style="line-height: 45px;" type="flex">
							<Cell :flex="1">今天过生日</Cell>
							<Cell><b class="text-hover" @click="loadBirthList('m1')">{{this.birth.m1}}</b>人
							</Cell>
						</Row>
						<Row style="line-height: 45px;" type="flex">
							<Cell :flex="1">七天内过生日</Cell>
							<Cell><b class="text-hover" @click="loadBirthList('m7')">{{this.birth.m7}}</b>人
							</Cell>
						</Row>
						<Row style="line-height: 45px;" type="flex">
							<Cell :flex="1">今天过生日学员</Cell>
							<Cell><b class="text-hover" @click="loadBirthList('s1')">{{this.birth.s1}}</b>人
							</Cell>
						</Row>
						<Row style="line-height: 45px;" type="flex">
							<Cell :flex="1">七天内过生日学员</Cell>
							<Cell><b class="text-hover" @click="loadBirthList('s7')">{{this.birth.s7}}</b>人
							</Cell>
						</Row>
					</div>
				</div>
			</Cell>
			<Cell width="14">
				<div class="h-panel">
					<Row type="flex" :space-x="5" class="padding">
						<Cell style="font-size: large">生日提醒</Cell>
						<Cell v-if="this.birthType" class="margin-left margin-right">
							<input v-width="180" type="text" placeholder="咨询师名字" v-model.trim="gcdfName">
						</Cell>
						<Cell v-if="this.birthType">
							<Button icon="icon-search" @click="loadBirthData">搜索</Button>
						</Cell>
					</Row>
					<Table :datas="dataList" :height="400">
						<TableItem title="学员">
            <span slot-scope="{data}" class="text-hover primary-color" @click="showMemberInfo(data)">
               {{ data.name }}
            </span>
						</TableItem>
						<TableItem title="身份证" prop="four"/>
						<TableItem title="咨询师" prop="gcdf"/>
						<TableItem title="生日">
								<span class="actions" slot-scope="{data}">
								{{data.birth|format('MM-DD')}}</span>
						</TableItem>
						<TableItem title="班级" :width="350" v-if="birthType == 's1' || birthType == 's7'">
							<div slot-scope="{data}">
								<TextEllipsis :key="data.clazz" :text="data.clazz" :height="40" v-width="300" useTooltip
								              tooltipTheme="white" placement="top">
									<template slot="more">...</template>
								</TextEllipsis>
							</div>
						</TableItem>
						<TableItem title="操作" align="center" :width="55">
						<span class="actions" slot-scope="{data}">
							<span class="text-hover" @click="relation(data)" ><i class="icon-mail"></i>跟进</span>
						</span>
						</TableItem>
					</Table>
					<Pagination v-model="bPage" :small="true" align="right"/>
				</div>
			</Cell>
			<!--<Cell width="8">-->
			<!--<div class="h-panel" style="height: 220px">-->
			<!--<div class="h-panel-bar">-->
			<!--<div class="h-panel-title">个人任务</div>-->
			<!--<div class="h-panel-right">-->
			<!--<span class="gray-color">年度总任务</span><i class="h-split"></i>-->
			<!--<span v-tooltip :content="0" class="font20 primary-color text-hover">{{0|moneyFormat}}</span>-->
			<!--<i class="h-split"></i><span class="gray-color">元</span>-->
			<!--</div>-->
			<!--</div>-->
			<!--<div class="h-panel-body">-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">本月任务</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="0">{{0|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">本月完成</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="0">{{0|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">本月差额</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="0">{{0|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--</div>-->
			<!--</div>-->
			<!--</Cell>-->
			<!--<Cell width="8">-->
			<!--<div class="h-panel" style="height: 220px">-->
			<!--<div class="h-panel-bar">-->
			<!--<div class="h-panel-title">本月支出</div>-->
			<!--<div class="h-panel-right">-->
			<!--<span class="gray-color">总支出</span><i class="h-split"></i>-->
			<!--<span v-tooltip :content="0"-->
			<!--class="font20 primary-color text-hover">{{0|moneyFormat}}</span>-->
			<!--<i class="h-split"></i><span class="gray-color">元</span>-->
			<!--</div>-->
			<!--</div>-->
			<!--<div class="h-panel-body">-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">教学</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="0">{{0|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">办公</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="0">{{0|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">维护</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="0">{{0|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--</div>-->
			<!--</div>-->
			<!--</Cell>-->
			<!--<Cell width="8">-->
			<!--<div class="h-panel" style="height: 220px">-->
			<!--<div class="h-panel-bar">-->
			<!--<div class="h-panel-title">本月收入</div>-->
			<!--<div class="h-panel-right"><span class="gray-color">总实收</span>-->
			<!--<i class="h-split"></i>-->
			<!--<span v-tooltip :content="stat.allReceipt "-->
			<!--class="font20 primary-color text-hover">{{stat.allReceipt |moneyFormat}}</span>-->
			<!--<i class="h-split"></i><span class="gray-color">元</span>-->
			<!--</div>-->
			<!--</div>-->
			<!--<div class="h-panel-body">-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">应收</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="stat.totalReceivable">{{stat.totalReceivable|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">新签实收</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip :content="stat.allReceipt">{{stat.allReceipt-stat.totalRepayment|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--<Row style="line-height: 45px;" type="flex">-->
			<!--<Cell :flex="1">回款</Cell>-->
			<!--<Cell><b class="text-hover" v-tooltip-->
			<!--:content="stat.totalRepayment">{{stat.totalRepayment|moneyFormat}}</b>元-->
			<!--</Cell>-->
			<!--</Row>-->
			<!--</div>-->
			<!--</div>-->
			<!--</Cell>-->
			<!--<Cell width="24">-->
			<!--<div class="h-panel">-->
			<!--<div class="h-panel-bar">-->
			<!--<div class="h-panel-title">教学数据统计</div>-->
			<!--</div>-->
			<!--<div class="h-panel-body home-part-body2">-->
			<!--<Row :space="20">-->
			<!--<Cell :width="24">-->

			<!--</Cell>-->
			<!--</Row>-->
			<!--</div>-->
			<!--</div>-->
			<!--</Cell>-->
		</Row>
		<!--<Row :space="30">-->
		<!--<Cell :xs='24' :sm='24' :md='24' :lg='16' :xl='16'>-->
		<!--<div class="h-panel">-->
		<!--<div class="relative">-->
		<!--<Tabs class="common-panel-tabs" v-model="type" :datas="{type1: '数据走势'}"></Tabs>-->
		<!--</div>-->
		<!--<div class="home-part-body">-->
		<!--<Chart :options="data1" v-if="type=='type1'" key="type1"></Chart>-->
		<!--<Cell v-if="type=='type2'">-->
		<!--<div class="h-panel">-->
		<!--<div class="h-panel-bar">-->
		<!--<div class="h-panel-title">订单统计</div>-->
		<!--<div class="h-panel-right"><span class="gray-color">总共达成</span><i-->
		<!--class="h-split"></i><span-->
		<!--class="font20 primary-color">{{stat.totalReceivable}}</span><i-->
		<!--class="h-split"></i><span-->
		<!--class="gray-color">元</span></div>-->
		<!--</div>-->
		<!--<div class="h-panel-body progress-div home-part-body">-->
		<!--<p v-for="data in statList">-->
		<!--<Progress :percent="data.maxReceivable" color="green"><span slot="title">{{data.name}}</span><span-->
		<!--slot="text">{{data.maxReceivable}}</span></Progress>-->
		<!--</p>-->
		<!--</div>-->
		<!--</div>-->
		<!--</Cell>-->
		<!--</div>-->
		<!--</div>-->
		<!--</Cell>-->
		<!--<Cell :xs='24' :sm='24' :md='24' :lg='8' :xl='8'>-->
		<!--<div class="h-panel">-->
		<!--<div class="relative">-->
		<!--<Tabs class="common-panel-tabs" v-model="debt"-->
		<!--:datas="{debt1: '过期回款', debt2: '最近回款', debt3: '远古账单'}" @change="change"></Tabs>-->
		<!--</div>-->
		<!--<div class=" progress-div home-part-body">-->
		<!--<Table :datas="outList" v-if="debt=='debt1'">-->
		<!--<TableItem title="姓名" :width="80">-->
		<!--<div slot-scope="{data}">-->
		<!--<div class="text-hover" @click="detail(data)">-->
		<!--<span class="blue-color">{{data.name}}</span>-->
		<!--</div>-->
		<!--</div>-->
		<!--</TableItem>-->
		<!--<TableItem title="回款时间" :width="100">-->
		<!--<div class="actions" slot-scope="{data}">-->
		<!--{{data.repay_date|format('YYYY-MM-DD')}}-->
		<!--</div>-->
		<!--</TableItem>-->
		<!--<TableItem title="咨询师" prop="gcdf" :width="80"/>-->
		<!--<TableItem title="课程" prop="groupName"/>-->
		<!--</Table>-->
		<!--<Button @click="toDebt()" color="primary" v-if="debt=='debt1'" icon="icon-fast-forward"-->
		<!--style="margin-top: 8px;margin-left: 150px">{{outPage.total}}条记录待查看-->
		<!--</Button>-->
		<!--<Table :datas="waitList" v-if="debt=='debt2'">-->
		<!--<TableItem title="姓名" :width="80">-->
		<!--<div slot-scope="{data}">-->
		<!--<div class="text-hover" @click="detail(data)">-->
		<!--<span class="blue-color">{{data.name}}</span>-->
		<!--</div>-->
		<!--</div>-->
		<!--</TableItem>-->
		<!--<TableItem title="回款时间" :width="100">-->
		<!--<div class="actions" slot-scope="{data}">-->
		<!--{{data.repay_date|format('YYYY-MM-DD')}}-->
		<!--</div>-->
		<!--</TableItem>-->
		<!--<TableItem title="咨询师" prop="gcdf" :width="80"/>-->
		<!--<TableItem title="课程" prop="groupName"/>-->
		<!--</Table>-->
		<!--<Button @click="toDebt()" color="primary" v-if="debt=='debt2'" icon="icon-fast-forward"-->
		<!--style="margin-top: 8px;margin-left: 150px">{{waitPage.total}}条记录待查看-->
		<!--</Button>-->
		<!--<Table :datas="noTimeList" v-if="debt=='debt3'">-->
		<!--<TableItem title="姓名" :width="80">-->
		<!--<div slot-scope="{data}">-->
		<!--<div class="text-hover" @click="detail(data)">-->
		<!--<span class="blue-color">{{data.name}}</span>-->
		<!--</div>-->
		<!--</div>-->
		<!--</TableItem>-->
		<!--<TableItem title="交费日期" :width="100">-->
		<!--<div class="actions" slot-scope="{data}">-->
		<!--{{data.payDay|format('YYYY-MM-DD')}}-->
		<!--</div>-->
		<!--</TableItem>-->
		<!--<TableItem title="咨询师" prop="gcdf" :width="80"/>-->
		<!--<TableItem title="课程" prop="groupName"/>-->
		<!--</Table>-->
		<!--<Button @click="toDebt()" color="primary" v-if="debt=='debt3'" icon="icon-fast-forward"-->
		<!--style="margin-top: 8px;margin-left: 150px">{{noTimePage.total}}条记录待查看-->
		<!--</Button>-->
		<!--</div>-->
		<!--</div>-->
		<!--</Cell>-->
		<!--    <Cell :xs='24' :sm='24' :md='24' :lg='16' :xl='16'>
						<div class="h-panel">
								<div class="h-panel-bar">
										<div class="h-panel-title">数据比例</div>
								</div>
								<div class="home-part-body2">
										<Chart :options="data2"></Chart>
								</div>
						</div>
				</Cell>
				<Cell :xs='24' :sm='24' :md='24' :lg='8' :xl='8'>
						<div class="h-panel">
								<div class="h-panel-bar">
										<div class="h-panel-title">数据比例</div>
								</div>
								<div class="h-panel-body home-part-body2">
										<Row :space="20">
												<Cell :width="10" class="text-right">
														<h-circle :percent="76" :stroke-width="10" :size="90">
																<p><span class="font28">{{parseInt(123*76/100)}}</span><span class="gray-color"> / 123</span>
																</p>
														</h-circle>
												</Cell>
												<Cell :width="14">
														<p color="green">网络项目</p>
														<p class="dark-color font22">122,332,98</p>
												</Cell>
												<p class="clearfix"></p>
												<Cell :width="10" class="text-right">
														<h-circle :percent="99" :stroke-width="10" :size="90" color="green">
																<p><span class="font28">{{parseInt(123*76/100)}}</span><span class="gray-color"> / 123</span>
																</p>
														</h-circle>
												</Cell>
												<Cell :width="14">
														<p color="red">学历项目</p>
														<p class="dark-color font22">122,332,98</p>
												</Cell>
												<p class="clearfix"></p>
												<Cell :width="10" class="text-right">
														<h-circle :percent="22" :stroke-width="10" :size="90" color="red">
																<p><span class="font28">{{parseInt(123*76/100)}}</span><span class="gray-color"> / 123</span>
																</p>
														</h-circle>
												</Cell>
												<Cell :width="14">
														<p class="gray-color">面授项目</p>
														<p class="dark-color font22">122,332,98</p>
												</Cell>
										</Row>
								</div>
						</div>
				</Cell>-->
		<!--</Row>-->
	</layout-content>
</template>

<script>

	import Chart from '../components/chart'
	import data2 from '../components/datas/data2'
	import data3 from '../components/datas/data4'

	export default {
		name: 'Home',
		components: {Chart},
		data() {
			return {
				data1: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['应收']
					},
					toolbox: {
						show: true,
						feature: {
							mark: {show: true},
							dataView: {show: true, readOnly: false},
							magicType: {show: true, type: ['line', 'bar']},
							restore: {show: true},
							saveAsImage: {show: true}
						}
					},
					calculable: true,
					xAxis: [
						// {
						//     // type: 'category',
						//     // boundaryGap: false,
						//     // data: []
						// }
					],
					yAxis: [
						{
							type: 'value',
							axisLabel: {
								formatter: '￥{value} '
							}
						}
					],
					series: [
						{
							name: '应收',
							type: 'line',
							data: [],
							markPoint: {
								data: [
									{type: 'max', name: '最大值'},
									{type: 'min', name: '最小值'}
								]
							},
							smooth: true,
							markLine: {
								data: [
									{type: 'average', name: '平均值'}
								]
							}
						}
					]
				},
				data2,
				data3,
				type: 'type1',
				debt: 'debt1',
				stat: {
					allRefund: 0,
					allReceipt: 0,
					totalRepayment: 0,
					totalReceivable: 0,
					totalRefund: 0,
				},
				data1xAxis: {
					type: 'category',
					boundaryGap: false,
					data: []
				},
				data1XList: [],
				data1Series: [],
				statDayList: [],
				statList: [],
				outList: [],
				waitList: [],
				noTimeList: [],
				maxStatList: {
					maxReceivable: 0,
					maxRefund: 0
				},
				outPage: {
					page: 1,
					size: 5,
					total: 0
				},
				waitPage: {
					page: 1,
					size: 5,
					total: 0
				},
				noTimePage: {
					page: 1,
					size: 5,
					total: 0
				},
				birthType: '',
				gcdfName: '',
				bPage: {
					page: 1,
					size: 5,
					total: 0
				},
				dataList: [],
				gcdfs: [],
				birth: {
					s1: '',
					s7: '',
					m1: '',
					m7: '',
				},
			}
		},
		watch: {
			bPage: {
				deep: true,
				handler() {
					this.loadBirthData()
				}
			}
		},
		methods: {
			change() {
				if (this.debt == "debt1") {
					this.loadDebtOut()
				}
				if (this.debt == "debt2") {
					this.loadDebtWait()
				}
				if (this.debt == "debt3") {
					this.loadNoTimeDebt()
				}
			},
			loadData() {
				this.$api.pay.payDetail.home().then(res => {
					this.stat = res.data
				})
			},
			loadStatList() {
				this.$api.pay.payDetail.statList().then(res => {
					this.statList = res.data
					this.maxStatList = this.statList[0]
				})
			},
			loadStatDay() {
				this.$api.pay.payDetail.statDay().then(res => {
					res.data.forEach((item) => {
						this.data1Series.push(item.receivable)
						this.data1XList.push(item.paymentDate)
					})

					this.$set(this.data1xAxis, "data", this.data1XList)
					this.data1.xAxis.push(this.data1xAxis)
					this.$set(this.data1, "xAxis[0]", this.data1xAxis)
					this.$set(this.data1.series[0], "data", this.data1Series)
				})
			},
			loadDebtOut() {
				this.$api.pay.debt.outList({
					page: this.outPage.page,
					size: this.outPage.size,
				}).then(res => {
						this.outList = res.data.records
						this.outPage.total = res.data.total
					}
				)
			},
			loadDebtWait() {
				this.$api.pay.debt.waitList({
					page: this.waitPage.page,
					size: this.waitPage.size,
				}).then(res => {
						this.waitList = res.data.records
						this.waitPage.total = res.data.total
					}
				)
			},
			loadNoTimeDebt() {
				this.$api.pay.debt.noTimeList({
					page: this.noTimePage.page,
					size: this.noTimePage.size,
				}).then(res => {
						this.noTimeList = res.data.records
						this.noTimePage.total = res.data.total
					}
				)
			},
			toDebt() {
				this.$router.push({name: 'Debt'})
			},
			detail(data) {
				this.$router.push({name: 'StudentDetail', params: {id: data.memberId}})
			},
			loadBirth() {
				this.$api.clue.member.birthNum().then(res => {
					this.birth = res.data
				})
			},
			loadBirthList(data) {
				this.birthType = data
				this.loadBirthData()
			},
			loadBirthData() {
				this.$api.clue.member.birthList({
					page: this.bPage.page,
					size: this.bPage.size,
					gcdfName: this.gcdfName,
					type: this.birthType
				}).then(res => {
					this.dataList = res.data.records
					this.bPage.total = res.data.total
				})
			},
			relation(data){
				this.$Modal({
					title: '生日跟进',
					closeOnMask: false,
					hasCloseIcon: true,
					component: {
						vue: (resolve) => require(['./clue/BirthFollowForm'], resolve),
						datas: {id: data.memberId},
					},
					events: {
						success: () => {
							this.loadData();
						}
					}
				})
			},
			showMemberInfo(data) {
				this.$Modal({
					title: '学员信息',
					hasMask: true,
					hasCloseIcon: true,
					hasDivider: true,
					type: 'drawer-right',
					esc: true,
					width: 1000,
					component: {
						vue: (resolve) => {
							require(['../views/clue/MemberInfo'], resolve);
						},
						datas: {id: data.memberId}
					},
					events: {
						$close: () => {
						},
						success: (modal) => {
							modal.close();
						}
					}
				});
			},
		},
		mounted() {
			// this.loadData()
			// this.loadStatList()
			// this.loadStatDay()
			// this.loadDebtOut()
			this.loadBirth()
		}
	}
</script>
<style lang="less">

	.info-box {
		display: block;
		min-height: 90px;
		background: #fff;
		width: 100%;
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
		border-radius: 2px;
		margin-bottom: 15px;

		small {
			font-size: 14px
		}

		.progress {
			background: rgba(0, 0, 0, 0.2);
			margin: 5px -10px 5px -10px;
			height: 2px;
			border-radius: 0;

			.progress-bar {
				border-radius: 0;
				background: #fff
			}
		}
	}

	.info-box-icon {
		border-radius: 2px 0 0 2px;
		display: block;
		color: #FFFFFF;
		float: left;
		height: 90px;
		width: 90px;
		text-align: center;
		font-size: 45px;
		line-height: 90px;
		background: rgb(252, 252, 252);
	}

	.info-box-icon > img {
		max-width: 100%;
	}

	.info-box-content {
		padding: 5px 10px;
		margin-left: 90px;
	}

	.info-box-number {
		display: block;
		font-weight: bold;
		font-size: 18px;
	}

	.progress-description, .info-box-text {
		display: block;
		font-size: 14px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.info-box-text {
		text-transform: uppercase;
	}

	.app-home-vue-h {
		background: #f0f2f5;
		padding-top: 20px;
		margin-top: 0 !important;

		.home-part-body {
			height: 350px;

			.echarts-vue {
				height: 350px;
			}
		}

		.home-part-body2 {
			height: 420px;

			.echarts-vue {
				height: 420px;
			}
		}

		.progress-div {
			> p {
				padding: 8px 0;
			}

			.h-progress {
				&-title {
					color: @dark2-color;
					font-size: 15px;
				}

				&-text {
					width: 40px;
				}
			}
		}
	}
</style>
